const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorResponse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 211.72 144.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.6,
    cy: 122.37,
    rx: 34.98,
    ry: 6.3,
    style: {
      fill: "#4aaed2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.87 7.67 61.76 32.03 51.69 19.91 50.93 24.49 40.51 11.39 40.96 3.27 47.01 13.77",
    style: {
      fill: "#4aaed2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78 21.85 72.58 8.35 76.32 7.83",
    style: {
      fill: "#4aaed2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.88 23.74 101.45 8.99 104.3 11.13",
    style: {
      fill: "#4aaed2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.89 33.2 126.88 21.78 128.42 25",
    style: {
      fill: "#4aaed2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85,54.57s3.65-5.26,3.78-5.35,4.61-4.95,4.61-4.95L64,39.83l4.78-2.78,1.13-.13,3.35,5,1.65,5.7-.08,5.08L73,56.31,70.58,61,68.41,62.7l-.83.43",
    style: {
      fill: "#d4eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.17,63l6.32,6.2,4.4,2-.66-2.77,1.38,1.39,1.14,1.93,1.75-2.17L84,72.74,85.19,72l5.6.3L96,71.78,107.16,69,114,65.57l4.15-2.95a21.4,21.4,0,0,1,2-1.62c.66-.42,4.75-2.29,4.75-2.29l4.64-.54,3-.24s-2-1.45-2.23-1.63a25.93,25.93,0,0,0-2.65-1s-3.37-.84-3.73-.9-2.65-.06-2.65-.06l-3.19.06-5.54,2L109,59.13,104.27,62l-5.72,1.75L93.74,64l-7.35-1-2.71-1.26-2.53-1.08H76.94",
    style: {
      fill: "#d4eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,70.66l-2-.69-4.66-3-2.77-3.34L69,62.38a.5.5,0,0,1-.51.41.52.52,0,0,1-.5-.68h0a3.81,3.81,0,0,0-.13-.45l-.3.6s-.06,3.17-.06,3.4-1.49,3-1.49,3l-2.76,3.05s-3.11,2.13-3.4,2.3-2.48.86-2.48.86l-2,.52-3,.63-2,.12L46.78,76,45,75.56l1.27,5.92L48.63,91l3.62,7.6,6.16,9,8,5.41,2.25.46L72.28,108l2.25-6,2.64-9.2,1.73-9.16.86-8.11Z",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,72.76s1,8.52,1,9.28.14,5.77.07,6.38-.48,6.73-.48,7-2.27,8.45-2.4,8.72-1.93,3.71-1.93,3.71l-3.7,4.26s-5.5,2.13-5.71,2.13-2.67.62-2.67.62l1.37-2.13,1.85-3.85,2-4.12,1.23-4.33,1.65-8.17,1-8L84.08,75,85,72.42",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.97 55.92 46.91 60.64 44.43 68.97 43.87 74.2 43.78 76.07 39.01 82.47 39.8 76.07 33.54 80.09 35.83 74.11 39.34 66.81 43.22 61.95",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.86 78.26 44.74 85.58 47.57 95.54 53.29 106.57 59.78 113.11 64.97 116.42 65.44 116.71 67.97 113.82 63.43 111.4 58.77 107.51 53 100.67 47.87 89.7 44.86 78.97 44.62 76.38 43.91 74.9",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.93,
    y1: 115,
    x2: 71.22,
    y2: 118.95,
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.02 36.56 108.37 40.29 106.63 43.81 106.38 46.57 106.63 49.28 108.24 52.19 111.47 56.24 112.58 56.6 115.08 55.82 117.58 54.5 121.18 54.12 123.86 54.12 127.42 54.54 131.28 56.24 132.81 57.81 129.88 52.08 123.6 44.66 115.5 38.13",
    style: {
      fill: "#1c2756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.19,69.77a12.08,12.08,0,0,1,.84-2s1.74-2.29,2-2.61a4.93,4.93,0,0,1,1.22-1.42c.49-.28.49-.63.73-.7s1.32-.21,1.32-.21,1.08.42,1.36.49a3.28,3.28,0,0,1,.84.59l-.25.73-4.39,7.8-.9-1.29-.59-1.29s-.73.8-.91,1-1.08-.14-1.08-.14",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "74.28 114.82 71.04 118.72 77.35 120.66 86.37 120.95 93.03 119.83 99.23 116.77 104.47 112.58 107.95 107.81 105.89 106.45 100.58 101.2 95.28 90.35 94.21 81.92 93.03 72.54 89.97 72.96 90.73 79.86 91.09 87.64 89.91 98.78 87.14 106.51 84.19 110.64 81.59 112.52 78.41 114.06 75.82 114.53 74.52 114.65",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.56,36.63l1.14,1.74L72,40.77l2.34,4.81L74.7,49v3.07l-1,3.27-3,5.21-1.14,2.08,4.34-1.41,6.55-.4,1.94.27,3.47,1.47,4.48,1.07,4.4.06,3.21.07,4.81-1.13,3.61-1.54,3.81-2.54,2.4-1.94a9.45,9.45,0,0,1-1.67-1.67,27.33,27.33,0,0,0-2.67-2.74s-1.07-2.27-1.2-2.8a31.6,31.6,0,0,1-.87-3.48c0-.53-.14-2.13.27-2.73s2.67-3.54,2.67-3.54l2.8-2.81s.67-.27.2-.6-3.8-1.87-3.8-1.87l-6.68-2.21-6.95-.87H86.79L78,33.16,74,34.56Z",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.47,68l-5.7,3.52L20.34,77.92,9,80.91,3.49,82l1.42,2.55,3.37,1.64,6.89.68,5.4-.3-3.3,1.8L8,92.37l-5.39,1.8H1.47L3,96.94l3.44,1.2,3.22.15,4.79-1.05,13.71-5.17-11.76,14,1.8,1,3.37-.23,4-.45,2.78-1.35.52,1.13,2.92.15,3.3-.45,6.06-3.52,6.52-5.62.45,1-.75,1.95s.52,1.35.9,1.35,2.32.45,2.32.45l.75.07-2.92-5.46-3.6-9.07L43.49,76.19l-4.65,6.89.9-7L33.6,80.31l2.47-7.19Z",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,72.56l1.68,13,2.39,9.26,3,5.47,3.37,3.86,3,2.17,3.37,1.47,2.1.35s1.4-.49,1.47-.7,1.41-5.19,1.41-5.19l3.5,3.3,3.79,3.29,6.45,3,2.81.91,3.64-1.33s4.21,1.68,4.42,1.68,2,.63,2.17.63,2.81-.14,2.81-.14l2.38-1.19-7.08-6.87-11.22-9.75-9.18-12.76-2-3.58L115.48,78l-1.19-1.75,1.12-.5s-1-2.17-1.19-2.52-2.67-3.16-2.74-3.37a27.64,27.64,0,0,0-2.52-2l-5.19,2.24-4.84,1.06",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,74.52l.77,3.16L131,91.84l11,9.26,3.64,1,5.12,1.26,5.26.14a25.6,25.6,0,0,1,2.6-.7c.35,0,2.45-2.45,2.45-2.45l-4-.42-6.31-2.32-10.17-5.47,4.56.07s5.05-.07,5.33,0,3.37-.42,3.37-.42l2-.84,2-1.68L159,87.57,155,87.5,148.09,86l-9.33-3.5-12.9-5.89-4.7-2.39Z",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.44,55.31l-3.37,8.51-1.89,6.91.21,2.86.37,1.58s2.37.67,2.64.73,2.53.55,3.05.55,5.14-1,5.41-1,7.45-3.74,7.45-3.74l3.07-3.59a25.59,25.59,0,0,0,1.37-2.89A24.92,24.92,0,0,0,68.06,62,27.49,27.49,0,0,0,67,59.05c-.06-.09-1.46-1.92-1.58-2l-3.47-1.61s-2.92-.64-3-.7a15.24,15.24,0,0,0-1.76-.34l-3.29,0a17.56,17.56,0,0,0-1.79.28c-.58.15-2.53.73-2.53.73",
    style: {
      fill: "#cc9ec8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.22,
    cy: 64.02,
    r: 6.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.46 53.66 44.67 56.72 51.47 44.55 46.79 43.62",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "58.2 121.76 60.05 122.55 60.85 123.79 61.55 125.29 61.55 126.17 65.52 124.05 73.01 116.74 77.15 109.6 80.5 101.75 82.27 92.85 83.33 82.89 84.21 73.72 83.41 69.75 82 71.16 79.27 68.08 79.27 73.28 79.18 81.39 77.24 91.7 75.13 100.34 71.51 109.68 66.4 116.03 62.7 118.94 59.17 121.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,77.33l2.73,2.17,6.23,10.08,10.61,11.68,8.56,6.42,9.87,5.43,7.15,2.3,4.85,1.48,3.05.58-.74,1,1.56,2.72.9,1.4,1.65.16,2.88,1.64,7.4,1s3.21-.16,3.54-.16h1.89l4.6-2.14H193a18.79,18.79,0,0,1,2.3,2l.83,1.73,3.53-.16,5.1-16.12-9-15.14-5.27.82L189.41,100,179,102.5l-1.32.9.17,1.15-.25,2.55L176,109.49l-1.57.16-2.87.33-2.23-.49-1.64,2.22-.25.9-7.15-2.22-13.24-5.75-12.83-9.3s-6.67-8.06-6.75-8.3-6.74-10.2-6.74-10.2l-.08-3.38.49-2.46-2.55,1.72-.33,3.38-3.37-.41-.61.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "109.66 67.82 111.58 69.6 114.42 73.82 115.3 75.33 117.17 75.77 118.45 75.94 119.15 72.28 114.93 67.05 113.15 65.85",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,128c.23,0,.8.49.91.53a10.3,10.3,0,0,1,.49,1.63l0,.79,6.81-3.14s2-1.4,2.12-1.4.19-1.17.12-1.36-.27-1-.57-1S57.6,124,57.6,124l-.68.38",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5,124.82a14.61,14.61,0,0,1,.61-2,12.39,12.39,0,0,1,1.89-.87c.15,0,1.44-.23,1.7-.23a16.24,16.24,0,0,1,2.73.68c0,.12.56,2.23.6,2.46a12.34,12.34,0,0,1-.41,1.89,9.28,9.28,0,0,1-1.22,1.37l-1.21.37-2.83.19,2-1.59.68-.87s.42-1.32.3-1.4-1.58-.79-1.58-.79l-2,.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.72,
    cy: 129.78,
    rx: 1.74,
    ry: 1.67,
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,98.67c.34,0,2.07-.16,2.35-.22s2-.06,2.19-.06a2.73,2.73,0,0,1,1.12.45,4.16,4.16,0,0,1,.28.67,7.42,7.42,0,0,1-.79,2.08c-.22.28-1.73,2.29-1.73,2.29",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,114c.34,0,1.74-.16,1.74-.16l2.29-.56,1.4.16.23.68a2.91,2.91,0,0,1-.12.89c-.11.23-.89,1.23-1,1.46a28.77,28.77,0,0,1-2,2.29l-2.12,1-2.3,1.12",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,43.68l0,0a.4.4,0,0,1-.18.1,1.12,1.12,0,0,0-.26.08,1.59,1.59,0,0,0-.29.15.55.55,0,0,1-.4,0C56,45.93,53.38,49.05,52.59,50a.56.56,0,0,1,.22.66l.31.26a91.78,91.78,0,0,1,6.26-6.86Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.56,63a.45.45,0,0,1,.2,0h.32l.09,0c4.22-4.24,6.32-8.82,6.22-13.62-.13-6.1-3.71-10.85-5.6-13l-.36.24a2.61,2.61,0,0,1-.52.28c1.75,1.93,5.36,6.61,5.48,12.46.09,4.63-2,9.07-6.23,13.2Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,64.53a26.58,26.58,0,0,1-11.47-2.64c-4-2-14.69,1.46-14.79,1.5l-.32-1c.46-.15,11.14-3.65,15.56-1.45,3.38,1.68,15.39,6.37,27.69-3.87a13.59,13.59,0,0,1,4-2.3,17.83,17.83,0,0,1,18,2.87l-.64.77a16.85,16.85,0,0,0-17-2.7,12.71,12.71,0,0,0-3.73,2.13C105.69,63,99.59,64.53,94.54,64.53Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,70.52l-.89-.45c.12-.24,3.06-6.07,5.42-7.6l.55.83C84.48,64.69,81.57,70.46,81.54,70.52Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,35.7s2.08-1,2.4-1.07-.22,1.17-.22,1.17L71,36.4",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53,57.16C108,53.7,105.74,50,105.87,46.23c.19-6,6.12-10,6.37-10.13l.55.83c-.05,0-5.75,3.89-5.92,9.33-.11,3.46,2,6.86,6.26,10.1Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,111.8a72.22,72.22,0,0,1-6.6-6.12,1.61,1.61,0,0,1-.38-.16,33.72,33.72,0,0,1-3-2.22,58.24,58.24,0,0,0,8.84,8.88,6.05,6.05,0,0,1-3.47.87c-3.6-.08-9.95-2.51-19.72-13.64a.5.5,0,0,0-.71,0,.48.48,0,0,0,0,.7c10.05,11.46,16.71,13.93,20.52,14h.13a6.17,6.17,0,0,0,4.45-1.52l.35-.39Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,99.8c-5.53-.08-14-4.8-17.69-7.07,15.31,1.6,16.62-4.9,16.67-5.19l.11-.66-.66.07c-9.09,1-29.52-9.1-29.78-9.23-.06,0-6.09-2.25-7.93-4a.5.5,0,0,0-.69.73c2,1.86,8,4.09,8.23,4.16.82.41,19.79,9.78,29.47,9.37-.87,1.57-4.36,5.33-17.53,3.45l-2.19-.31,1.85,1.22c.49.33,11.81,7.8,19.37,8.39a4.33,4.33,0,0,1-2,1.61c-2.69,1.2-8.26,1.38-19.56-3.8l.19.19a4,4,0,0,0,.36.35s.26.17,0,0l.13.1c.33.27.7.5,1,.74.52.34,1,.7,1.51,1.08,9.3,3.72,14.2,3.36,16.76,2.2a4.74,4.74,0,0,0,2.76-2.84l.15-.61Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,112.92c-3.34,0-9.3-2.18-18.93-12.35a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0c9.41,9.94,15.09,12,18.2,12h.07a3.87,3.87,0,0,0,2.79-.91.5.5,0,0,1,.75.66,4.73,4.73,0,0,1-3.44,1.25Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,108.76c-1.9,0-4.4-1.15-7.47-3.45-.29-.25-6.57-5.78-9-16.5l-.17-.57c0-.06-.39-1.51-1.81-15.63l1-.1C95,86.29,95.38,87.91,95.39,88l.17.58a31.64,31.64,0,0,0,8.63,16c3.75,2.81,6.58,3.82,8.17,2.91,2.07-1.19,1.62-5.31,1.62-5.36l1-.11c0,.2.53,4.82-2.11,6.34A3.65,3.65,0,0,1,111,108.76Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31,102.72c-8.9,7.57-16.26,3.94-16.35,3.89l-.56-.29L26.75,93.07C12.17,100,5.89,99.48,3.2,97.75a4.41,4.41,0,0,1-2.14-3.63l0-.58.57.1c2.4.43,11.55-3.82,17.09-6.6C4.33,88.7,3,82.16,2.9,81.86l-.09-.53.54,0c19-1.85,35.56-14.49,35.72-14.62a.52.52,0,0,1,.71.09.49.49,0,0,1-.1.71c-.16.12-16.61,12.65-35.59,14.75.74,1.52,4.05,5.72,17.45,3.41l3.11-.54-2.79,1.47c-1.61.85-15.19,8-19.74,8.11a3.58,3.58,0,0,0,1.64,2.27c2.62,1.65,9,2,24.71-5.81L30.67,90,17,106c2.46.91,12,3,22-12.73a.5.5,0,0,1,.84.54A38.65,38.65,0,0,1,32.31,102.72Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,101.81a3.78,3.78,0,0,1-.49-1l-.36-.07a2.14,2.14,0,0,1-1.63-1.31,3.69,3.69,0,0,1,.34-2.38c-.11-.23-.21-.45-.33-.67L48,96l-.13-.18a.18.18,0,0,0,0-.07l-.05-.07-.07-.08,0,0c-8.18,8.4-13.4,10.3-16.38,10.32a4.36,4.36,0,0,1-3.11-1,.51.51,0,0,0-.7,0,.5.5,0,0,0,0,.71,5.19,5.19,0,0,0,3.77,1.27c3.05,0,8.25-1.74,16.18-9.61a4.1,4.1,0,0,0-.13,2.44,3.07,3.07,0,0,0,2.3,2,5.88,5.88,0,0,0,1.22.18Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,64a6.88,6.88,0,1,1,6.88,6.88A6.89,6.89,0,0,1,51.25,64Zm1,0a5.88,5.88,0,1,0,5.88-5.88A5.89,5.89,0,0,0,52.25,64Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,44.16l-7.24,14-2.56-3.69,4-11.47ZM44.81,55.91l5.55-10.77-3.53-.68L43.5,54Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.17,84.42,44.38,76l-.81-.59-4,5.36L40.3,75l-5.68,3.93,1.63-4.57A58.5,58.5,0,0,1,49.74,55.61l.65-.47-.59-.81-.68.49A59.79,59.79,0,0,0,35.32,74l-2.68,7.53L39,77.08Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,131.67a.51.51,0,0,1-.5-.45l-.82-7.58-5-10.39a.49.49,0,0,1,.23-.66.5.5,0,0,1,.67.23l5.1,10.63.84,7.66a.5.5,0,0,1-.44.55Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,124a.59.59,0,0,1-.23,0,.51.51,0,0,1-.22-.68l5.05-10a.5.5,0,0,1,.67-.22.49.49,0,0,1,.22.67l-5.05,10A.5.5,0,0,1,32.22,124Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.24,124.34a.51.51,0,0,1-.47-.33.5.5,0,0,1,.3-.64l28.1-10.26a.5.5,0,1,1,.34.94l-28.1,10.26A.51.51,0,0,1,32.24,124.34Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.24,131.38h-.06a.5.5,0,0,1-.43-.56l.93-6.9L103.31,114a.51.51,0,0,1,.37-.94l26.1,10.2-1,7.68A.51.51,0,0,1,128.24,131.38Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,124.66l-5.54-11.42a.5.5,0,0,1,.9-.44l4.72,9.73,4.58-7.91a.5.5,0,0,1,.87.5Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.66,66.43a.46.46,0,0,1-.23-.06.5.5,0,0,1-.22-.67l2.56-5.08a.5.5,0,1,1,.9.44L57.1,66.15A.49.49,0,0,1,56.66,66.43Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.63,65.17a.46.46,0,0,1-.23-.06l-5.09-2.56a.51.51,0,0,1-.22-.67.49.49,0,0,1,.67-.22l5.09,2.56a.49.49,0,0,1,.22.67A.48.48,0,0,1,60.63,65.17Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.08,123.07a1.83,1.83,0,0,1-.89-.24c-1.67-.89-2.65-4.15-2.75-4.52a.48.48,0,0,1,.34-.61.49.49,0,0,1,.62.34c.26.89,1.16,3.32,2.26,3.91a.82.82,0,0,0,.66.08c1.63-.52,2.15-4.7,2.15-6.64,0-1-1.93-3.63-3.27-5.24-.22.15-.71.76-1,2.54a.49.49,0,0,1-.58.4.51.51,0,0,1-.41-.58c.3-1.67.8-2.74,1.48-3.18a1.15,1.15,0,0,1,.87-.19l.16,0,.1.13c.61.73,3.67,4.45,3.67,6.09,0,.27,0,6.69-2.84,7.59A1.81,1.81,0,0,1,170.08,123.07Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84,127.37l-.16-.34s-1.32-2.89-3.11-3.53a1.35,1.35,0,0,0-.9,0c-5.49,2.14-5.95,2.14-6.1,2.14l-.33,0c-5.59.3-12.69,0-14.79-2.92a.5.5,0,0,1,.12-.7.51.51,0,0,1,.7.12c1.41,2,6.48,2.9,13.91,2.5l.39,0c.28,0,2.17-.68,5.74-2.07a2.33,2.33,0,0,1,1.6-.06c1.79.64,3.08,2.86,3.52,3.72l3-.39,4.92-15-9.13-14.82-4.61.5-.76,3.9-.32.07c-5.17,1.16-10.85,2.62-11.41,3.06s.16,1.33.16,1.34l.09.11v.14a4.23,4.23,0,0,1-3.5,4.88h-5.45a.5.5,0,1,1,0-1h5.38a3.2,3.2,0,0,0,2.59-3.64,1.94,1.94,0,0,1,.06-2.58c.86-.76,8.66-2.57,11.53-3.21l.78-4,6-.65,9.71,15.75-5.27,16Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.14,127.33l-.12,0a.5.5,0,0,1-.36-.61l3.88-15.16-9.78-15.11a.5.5,0,0,1,.15-.69.51.51,0,0,1,.69.15l10,15.47-4,15.59A.49.49,0,0,1,196.14,127.33Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,104.07a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71c1.44-1.51,2.7-3.54,2.22-4-.65-.65-3.14-.32-4.7.12a.48.48,0,0,1-.61-.34.5.5,0,0,1,.34-.62c.72-.2,4.39-1.17,5.68.13s-1.33,4.49-2.2,5.41A.52.52,0,0,1,201,104.07Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72,121.56a.5.5,0,0,1-.16-1c3.61-1.17,7.36-4.33,7.44-6.27,0-.23-.06-.31-.15-.37-.7-.53-3.26,0-4.85.57a.49.49,0,0,1-.64-.3.5.5,0,0,1,.31-.64c.72-.25,4.39-1.46,5.78-.44a1.4,1.4,0,0,1,.55,1.22c-.11,2.6-4.46,6-8.13,7.19Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.49,118.53l-.26,0c-35.53-6.76-49.32-32.93-51.73-38.11h0a2.63,2.63,0,0,0-1.18-1.22c-1.53-.79-2.4-1.63-2.57-2.5a1.1,1.1,0,0,1,.33-1.11c.8-.69,2.72-.13,3.79.26,0,0,.31-.38.29-2.57v-.14c0-.22,0-.89,2.88-2.27l1-.48-.28,1.06s-.91,3.43-.11,5.55S130,89.52,130,89.62c14.41,17.52,39.15,23,39.4,23.07l.21,0,.11.19c2,3.27-.05,5.4-.08,5.42ZM118.41,80c2.36,5.08,15.88,30.73,50.71,37.49a3.4,3.4,0,0,0-.12-3.82c-2.49-.59-25.84-6.46-39.76-23.39-.33-.45-7.67-10.58-8.55-12.92a10.63,10.63,0,0,1-.15-5.11,5.35,5.35,0,0,0-1.4,1l0,0c0,2-.2,3-.76,3.4a.92.92,0,0,1-.87.11c-1.63-.6-2.67-.6-2.8-.44s0,.06,0,.16c.11.53.85,1.19,2,1.8A3.61,3.61,0,0,1,118.41,80Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4,75.94a.49.49,0,0,1-.44-.26,25.75,25.75,0,0,0-5.73-7.2.51.51,0,0,1-.08-.71.49.49,0,0,1,.7-.07,26.28,26.28,0,0,1,6,7.5.5.5,0,0,1-.2.68A.53.53,0,0,1,115.4,75.94Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,73.28a.49.49,0,0,1-.45-.29c-1.35-3-4.93-6.29-5-6.33a.5.5,0,1,1,.68-.73c.15.14,3.77,3.49,5.2,6.65a.51.51,0,0,1-.25.66A.52.52,0,0,1,118.83,73.28Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,121.36a4,4,0,0,0-4,4,3.68,3.68,0,0,0,.06.58,1.42,1.42,0,0,1,1-.41,1,1,0,0,1,0-.17,3,3,0,0,1,6.06,0,3,3,0,0,1-1,2.24,3.08,3.08,0,0,1-2,.75,3,3,0,0,1-1.57-.45,1.35,1.35,0,0,1-.78.68,4,4,0,0,0,2.35.77,4,4,0,0,0,2.65-1,4,4,0,0,0,1.38-3A4,4,0,0,0,58,121.36Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.88,69.33A.83.83,0,0,0,83.3,69L83,69l-1.08,1.66-2.87-4.45-.87.48c0,.07,3.17,7.11-1.5,25.58-.26,1-.49,2.1-.7,3.31C75.19,100,71.53,115,57.75,121.4a.5.5,0,0,0-.24.67.49.49,0,0,0,.66.24c14.22-6.6,18-22,18.8-26.59.21-1.18.44-2.23.69-3.23C80.74,80.31,80.5,73,79.91,69.34l2,3.14,1.37-2.12c.29.83.68,3.26-.16,10.14-.15,1.17-.27,2.48-.41,3.9-1.1,11.51-3,30.7-21.55,41.7a.15.15,0,0,1,0,.07.54.54,0,0,1,0,.28.13.13,0,0,1,0,.06c0,.1,0,.2,0,.3a.65.65,0,0,1-.1.36l-.09.12h0a.55.55,0,0,0,.25-.07C80.71,116,82.6,96.28,83.73,84.49c.13-1.4.26-2.7.4-3.87C84.89,74.36,84.81,70.46,83.88,69.33Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.46,63.33h0l.13,0-.13,0c-1.46,2.11-5.79,8.69-6,13a.49.49,0,0,0,.47.52h0a.5.5,0,0,0,.49-.48c.19-4.43,5.23-11.74,6.11-13C90.22,63.41,89.84,63.39,89.46,63.33Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,123.37a2.27,2.27,0,0,0-1.94,1.08,1.84,1.84,0,0,1,.33,0,2.14,2.14,0,0,1,.45,0h.19a2.07,2.07,0,0,1,.69.12.88.88,0,0,1,.28-.06,1.12,1.12,0,0,1,1.13,1.1,1.05,1.05,0,0,1-.41.83,1.56,1.56,0,0,1-1.12,1.27,1.76,1.76,0,0,0,.4.06,2.16,2.16,0,1,0,0-4.32Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.71,131.94a2.22,2.22,0,1,1,2.18-2.22A2.21,2.21,0,0,1,48.71,131.94Zm0-3.44a1.22,1.22,0,1,0,1.18,1.22A1.2,1.2,0,0,0,48.71,128.5Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,71.16l2.55-.36s2.08-.64,2.44-.8-.38-.34-.38-.34l-.75.17-1.31.35-1.1.37",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,128.6a.5.5,0,0,1-.48-.34.52.52,0,0,1,.32-.64,62.36,62.36,0,0,0,9.15-4,.5.5,0,0,1,.48.88,64.41,64.41,0,0,1-9.31,4Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68,131.61a.5.5,0,0,1-.18-1c.06,0,6.67-2.58,9.28-4.43a.5.5,0,1,1,.58.82c-2.71,1.91-9.23,4.44-9.5,4.55Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46,50.63a.53.53,0,0,1-.24-.06l-9.39-5a.5.5,0,1,1,.47-.89l9.39,5a.5.5,0,0,1-.23.94Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82,46.53a.5.5,0,0,1-.34-.13l-7.8-7.24a.5.5,0,1,1,.68-.73l7.8,7.23a.51.51,0,0,1,0,.71A.5.5,0,0,1,38.82,46.53Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,55.31a.5.5,0,0,1-.5-.5.49.49,0,0,1,.49-.5l10.63-.14h0a.5.5,0,0,1,.5.49.51.51,0,0,1-.49.51l-10.64.14Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.37,74.68a12.62,12.62,0,0,0,1.35.52,17.88,17.88,0,0,0,10.68-.31C64,72.44,68.72,66.16,67,60.88c-.81-2.53-3-4.46-6.13-5.44a15.7,15.7,0,0,0-4.65-.68,19.51,19.51,0,0,0-6,1c-.4.13-.79.27-1.18.42A7.58,7.58,0,0,0,49.45,55l.44-.17a18.93,18.93,0,0,1,11.29-.3C64.64,55.57,67,57.73,68,60.57c1.88,5.8-3.17,12.65-11.25,15.27a20.61,20.61,0,0,1-6.35,1,16.62,16.62,0,0,1-4.94-.72c-.39-.12-.75-.26-1.11-.4A6.4,6.4,0,0,0,44.37,74.68Z",
    style: {
      fill: "#a574a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.38,113.91c.12-.12.24-.23.35-.35-7.38-2.37-19.9-11-24.21-42.22l-.31,0s0,0,0,0l0,.06-.06.1c-.12.33-.16.69-.25,1a.42.42,0,0,1-.1.2c4.46,30,16.64,38.91,24.26,41.54A3.38,3.38,0,0,1,68.38,113.91Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,72.83l-1,.18c0,.24,4.26,24.38-4.44,35.68a14.51,14.51,0,0,1-10.73,5.72h-.21a2,2,0,0,1-.3.82l-.14.18h.11c.39,0,.61,0,.64,0a15.41,15.41,0,0,0,11.42-6.1C94.87,97.64,90.71,73.84,90.53,72.83Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,116.68a.76.76,0,0,1,.42-.33h.06a2.46,2.46,0,0,0,.34-.22,43.86,43.86,0,0,1-4-2.32A27.12,27.12,0,0,1,54.11,106C43.45,89.8,41.49,74,48.28,59.06a44,44,0,0,1,5.6-9.1,3.5,3.5,0,0,1-1.25,0,44.61,44.61,0,0,0-5.26,8.69c-6.85,15.07-4.81,31.63,5.9,47.88a28.08,28.08,0,0,0,8,8.1c1,.69,2.29,1.44,3.68,2.17C65,116.76,65,116.71,65,116.68Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34,107.2A25,25,0,0,1,96.23,118a35.49,35.49,0,0,1-24.82.52.6.6,0,0,1-.17.3,1.52,1.52,0,0,1-.9.37,37.51,37.51,0,0,0,12.82,2.32A36.79,36.79,0,0,0,96.6,118.9a26.14,26.14,0,0,0,11.67-11.33A3.12,3.12,0,0,1,107.34,107.2Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,57.75c-.16-.32-16-32.43-50.14-26.35a52.09,52.09,0,0,0-11.23,3.36,6.49,6.49,0,0,1-1.26.55.51.51,0,0,1-.52.5.57.57,0,0,1-.33-.11,49.23,49.23,0,0,0-12.53,8.61l.51,0a1.67,1.67,0,0,0,.32-.08h0a.71.71,0,0,1,.73,0,48.56,48.56,0,0,1,11.9-7.88.06.06,0,0,0,0,0,.44.44,0,0,1,.12-.18.39.39,0,0,1,.17-.11.54.54,0,0,1,.21-.05h.09l.14,0,.14-.07a.49.49,0,0,1,.36-.06,51,51,0,0,1,11.34-3.42c30.6-5.46,46.22,20.55,48.71,25.13-2.66.17-11.17,1-14.84,4.82-2.5,2.59-18.63,11.66-33,9.43l-.44-.08c.05.34.08.69.1,1l.18,0c6.11,1,12.71-.16,18.49-2a2.5,2.5,0,0,1,1.88-.77c.12,0,.23,0,.35,0,6.43-2.29,11.52-5.32,13.15-7,4-4.17,14.83-4.55,14.94-4.55l.76,0Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,62.84a6.3,6.3,0,0,1-.89.07h-.28a22,22,0,0,0,10.48,8.5c0-.35,0-.71,0-1.06A21,21,0,0,1,70,62.84Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,60.54c-.92-2.84-3.33-5-6.79-6.09a18.67,18.67,0,0,0-10.45.07,1.82,1.82,0,0,1,.14,1,19.84,19.84,0,0,1,5.37-.79,15.59,15.59,0,0,1,4.64.68c3.14,1,5.32,2.91,6.14,5.44,1.7,5.27-3.06,11.56-10.62,14a17.8,17.8,0,0,1-10.68.3c-.14,0-.26-.09-.39-.14a1.74,1.74,0,0,1,0,1.06l.11,0a16.69,16.69,0,0,0,4.95.72,20.55,20.55,0,0,0,6.34-1C64.84,73.19,69.89,66.34,68,60.54Z",
    style: {
      fill: "#a574a5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorResponse);
export default __webpack_public_path__ + "static/media/error_response.d10fb94caa6d722287336e22f0dc7537.svg";
export { ForwardRef as ReactComponent };